<template>
  <section class="banner-section">
    <img :src="$t('Header.DtpHeader')" class="d-none d-md-block img-fluid w-100"
      alt="P&G Zevo Walmart banner" />
    <img :src="$t('Header.MobHeader')" class="d-md-none img-fluid w-100"
      alt="P&G Zevo Walmart banner" />
  </section>  
</template>

<script>
export default {
  name: 'Carousel',
};
</script>

<style scoped>
/* Hide numbers in carousel indicators */
.carousel-indicators button {
  background-color: #fff; /* Optional: Change color if needed */
}

.carousel-indicators button::after {
  content: ''; /* Remove the default text content */
}

.carousel-indicators button[data-bs-slide-to] {
  position: relative;
}

.carousel-indicators button[data-bs-slide-to]::after {
  display: none; /* Hide numbers */
}
</style>
